import { PureComponent } from "react";
import { connect } from "react-redux";
import "./PaymentTypeInput.scss";
import { CIVILITY, CREDIT_CARDS_TYPES, PAYMENT_METHODS, PAYMENT_OPTIONS } from "app/constants";
import { FormattedMessage } from "react-intl";
import SwissBillingPaymentType from "app/pages/Booking/Payment/PaymentData/PaymentDataModeFirst/PaymentMethodsFieldsetNew/SwissBilling/SwissBillingPaymentType";
import IdealPaymentType from "app/pages/Booking/Payment/PaymentData/PaymentDataModeFirst/PaymentMethodsFieldsetNew/Ideal/IdealPaymentType";
import Radio from "app/pages/.shared/form/Radio";
import PropTypes from "prop-types";
import CasinoPaymentType from "app/pages/Booking/Payment/PaymentData/PaymentDataModeFirst/PaymentMethodsFieldsetNew/Casino/CasinoPaymentType";
import CreditCardPaymentType from "app/pages/Booking/Payment/PaymentData/PaymentDataModeFirst/PaymentMethodsFieldsetNew/creditCard/CreditCardPaymentType";
import CreditCardPictos from "app/pages/.shared/CreditCardPictos/CreditCardPictos";
import CreditCardFieldsetContainer from "app/pages/Booking/Payment/CreditCardFieldset/CreditCardFieldsetContainer";

class PaymentTypeInput extends PureComponent {
	render() {
		const {
			fields = {},
			paymentType = {},
			ideal = {},
			casino = { mensualiteCasino: {}, forbiddenCause: "" },
			mensualite2Fois = {},
			total,
			onCreditCardInputsBlur,
			onCreditCardInformationChange,
			onChange,
			disabled,
			swissbilling = { forbiddenCause: "", cgvURL: "" },
			showAmountToPay,
			shop,
		} = this.props;

		let bodyComponent = false;
		let headerComponent = false;
		let conditionnalDisabled = disabled;
		let conditionnalForbiddenComponent = false;

		let acceptedCreditCardTypes = paymentType.acceptedCreditCardTypes;

		if (shop === "fr-FR" && acceptedCreditCardTypes && acceptedCreditCardTypes.length > 0) {
			acceptedCreditCardTypes = [CREDIT_CARDS_TYPES.CB].concat(acceptedCreditCardTypes);
		}

		const creditCardIcons = <CreditCardPictos creditCardCodes={acceptedCreditCardTypes} />;

		if (paymentType.paymentType === PAYMENT_METHODS.CARD) {
			headerComponent = (
				<div className="payment-type__line">
					<FormattedMessage id="payment.method.adyen_cse_card" />
					{creditCardIcons}
				</div>
			);

			if (disabled) {
				bodyComponent = false;
			} else if (paymentType.terms === PAYMENT_OPTIONS["1x"]) {
				bodyComponent = (
					<CreditCardPaymentType
						payNowAmount={total}
						onCreditCardInputsBlur={onCreditCardInputsBlur}
						onCreditCardInformationChange={onCreditCardInformationChange}
						field={fields.payment.card}
						showAmountToPay={showAmountToPay}
					/>
				);
			} else if (paymentType.terms === PAYMENT_OPTIONS["2x"]) {
				bodyComponent = (
					<CreditCardPaymentType
						payNowAmount={mensualite2Fois.payNowAmount}
						payLaterAmount={mensualite2Fois.payLaterAmount}
						dueDate={mensualite2Fois.dueDate}
						onCreditCardInputsBlur={onCreditCardInputsBlur}
						onCreditCardInformationChange={onCreditCardInformationChange}
						field={fields.payment.card}
						showAmountToPay={showAmountToPay}
					/>
				);
			}
		} else if (paymentType.paymentType === PAYMENT_METHODS.CASINO) {
			headerComponent = (
				<div className="payment-type__line">
					<FormattedMessage id="payment.method.adyen_cse_card" />
					{creditCardIcons}
				</div>
			);

			bodyComponent = !disabled && (
				<CasinoPaymentType
					payNowAmount={casino.mensualiteCasino.apport}
					field={fields.payment.card}
					onCreditCardInputsBlur={onCreditCardInputsBlur}
					showMaidenName={fields.contact.name.gender.value === CIVILITY.FEMALE}
				/>
			);
		} else if (paymentType.paymentType === PAYMENT_METHODS.BCMC) {
			headerComponent = (
				<div className="payment-type__line">
					<FormattedMessage id="payment.method.bcmc" />
					<div className="payment-type__icons">
						<i className={`icon icon--bancontact payment-type__icon`} />
					</div>
				</div>
			);

			bodyComponent = !disabled && (
				<CreditCardFieldsetContainer
					fields={fields.payment.cardBCMC}
					onBlur={onCreditCardInputsBlur}
					onCreditCardInformationChange={onCreditCardInformationChange}
				/>
			);
		} else if (paymentType.paymentType === PAYMENT_METHODS.SWISS_BILLING) {
			conditionnalForbiddenComponent = swissbilling.forbiddenCause;
			conditionnalDisabled = disabled || swissbilling.forbiddenCause;
			headerComponent = (
				<div>
					<div className="payment-type__line">
						<FormattedMessage
							id="payment.method.swissbilling"
							values={{
								note: (
									<span className="payment-type__note">
										<FormattedMessage id="payment.method.swissbilling.2" />
									</span>
								),
							}}
						/>
						<div className="payment-type__icons">
							<i className={`icon icon--swissbilling payment-type__icon`} />
						</div>
					</div>
					<div className="payment-type__line--note">
						<FormattedMessage id="payment.method.swissbilling.note" />
					</div>
				</div>
			);

			bodyComponent = !conditionnalDisabled && (
				<SwissBillingPaymentType
					fields={fields.payment.swissBilling}
					swissBillingCGVURL={swissbilling.cgvURL}
					total={total}
					maxAmount={swissbilling.maxAmount}
				/>
			);
		} else if (paymentType.paymentType === PAYMENT_METHODS.IDEAL) {
			headerComponent = (
				<div className="payment-type__line">
					<FormattedMessage id="payment.method.ideal" />
					<div className="payment-type__icons">
						<i className={`icon icon--ideal payment-type__icon`} />
					</div>
				</div>
			);
			bodyComponent = !disabled && (
				<IdealPaymentType
					total={total}
					idealIssuers={paymentType.issuers}
					onIssuerSelect={ideal.onPaymentBankChange}
					field={fields.payment.issuerId}
				/>
			);
		} else if (paymentType.paymentType === PAYMENT_METHODS.SOFORT) {
			headerComponent = (
				<div className="payment-type__line">
					<FormattedMessage id="payment.method.sofort" />
					<div className="payment-type__icons">
						<i className={`icon icon--sofort payment-type__icon`} />
					</div>
				</div>
			);
		} else if (paymentType.paymentType === PAYMENT_METHODS.GIROPAY) {
			headerComponent = (
				<div className="payment-type__line">
					<FormattedMessage id="payment.method.giropay" />
					<div className="payment-type__icons">
						<i className={`icon icon--giropay payment-type__icon`} />
					</div>
				</div>
			);
		} else if (paymentType.paymentType === PAYMENT_METHODS.POSTFINANCE_CARD) {
			headerComponent = (
				<div className="payment-type__line">
					<FormattedMessage id="payment.method.postfinance_card" />
					<div className="payment-type__icons">
						<i className={`icon icon--postfinance-card payment-type__icon`} />
					</div>
				</div>
			);
		} else if (paymentType.paymentType === PAYMENT_METHODS.POSTFINANCE_EFINANCE) {
			headerComponent = (
				<div className="payment-type__line">
					<FormattedMessage id="payment.method.postfinance_efinance" />
					<div className="payment-type__icons">
						<i className={`icon icon--postfinance-efinance payment-type__icon`} />
					</div>
				</div>
			);
		} else if (paymentType.paymentType === PAYMENT_METHODS.PAYPAL) {
			headerComponent = (
				<div className="payment-type__line">
					<FormattedMessage id="payment.method.paypal" />
					<div className="payment-type__icons">
						<i className={`icon icon--paypal payment-type__icon`} />
					</div>
				</div>
			);
		}

		const isPaymentMethodSelected = fields.payment.type.value === paymentType.paymentType;

		return (
			<div className="payment-type">
				{conditionnalForbiddenComponent && (
					<div className="payment-methods-fieldset-new__message--forbidden">
						{conditionnalForbiddenComponent}
					</div>
				)}
				{conditionnalDisabled ? (
					<Radio
						field={fields.payment.type}
						showIcon={true}
						name={paymentType.paymentType}
						id={paymentType.paymentType}
						value={paymentType.paymentType}
						disabled={conditionnalDisabled}
						data-testid={`payment-type-input-${paymentType.paymentType}`}
					>
						<div className="payment-type__content">{headerComponent}</div>
					</Radio>
				) : (
					<Radio
						field={fields.payment.type}
						showIcon={true}
						name={paymentType.paymentType}
						id={paymentType.paymentType}
						value={paymentType.paymentType}
						body={
							isPaymentMethodSelected &&
							bodyComponent && (
								<div className="payment-type__body">{bodyComponent}</div>
							)
						}
						checked={isPaymentMethodSelected}
						toggle={() => {
							onChange(paymentType.paymentType);
						}}
						data-testid={`payment-type-input-${paymentType.paymentType}`}
					>
						<div className="payment-type__content">{headerComponent}</div>
					</Radio>
				)}
			</div>
		);
	}
}

PaymentTypeInput.propTypes = {
	paymentType: PropTypes.object,
	onCreditCardInputsBlur: PropTypes.func,
	onCreditCardInformationChange: PropTypes.func,
	onChange: PropTypes.func,
	casino: PropTypes.shape({
		mensualiteCasino: {
			apport: PropTypes.number,
			coutCredit: PropTypes.number,
			mensualite: PropTypes.number,
		},
	}),
	total: PropTypes.number,
	mensualite2Fois: PropTypes.object,
	swissbilling: PropTypes.object,
	disabled: PropTypes.bool,
	fields: PropTypes.object,
	ideal: PropTypes.object,
	showAmountToPay: PropTypes.bool,
	shop: PropTypes.string,
};

const mapStateToProps = state => {
	return {
		shop: state.shop,
	};
};

export default connect(mapStateToProps)(PaymentTypeInput);
